module.exports = __WEBPACK_EXTERNAL_MODULE__4521__;